import React from "react";
import "./FilterBar.css";

interface FilterBarProps {
  fromDate: string;
  toDate: string;
  searchQuery: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  onSearchQueryChange: (query: string) => void;
  onApplyFilters: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  fromDate,
  toDate,
  searchQuery,
  onFromDateChange,
  onToDateChange,
  onSearchQueryChange,
  onApplyFilters,
}) => {
  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onApplyFilters();
  };

  return (
    <div className="filter-bar">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <input
          type="search"
          placeholder="Search articles..."
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          className="search-input"
        />
      </form>
      <div className="filter-group">
        <label htmlFor="from-date">From:</label>
        <input
          type="date"
          id="from-date"
          value={fromDate}
          onChange={(e) => onFromDateChange(e.target.value)}
        />
      </div>
      <div className="filter-group">
        <label htmlFor="to-date">To:</label>
        <input
          type="date"
          id="to-date"
          value={toDate}
          onChange={(e) => onToDateChange(e.target.value)}
        />
      </div>
      <button className="apply-button" onClick={onApplyFilters}>
        Apply
      </button>
    </div>
  );
};

export default FilterBar;
